import { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { commentPrice, commentUserName, CommentStatus } from './MobileDiscoveryCommentCard';
import icImg from '../../assets/img/ic-img.svg';

// showEmail: commenter emails are for moderation, so only platform admins get the row.
export default function MobileCommentDetail({ comment, onClose, showEmail = false }) {
    const [photoIndex, setPhotoIndex] = useState(0);
    const photos = Array.isArray(comment.photos) ? comment.photos : [];
    return (
        <Modal show fullscreen onHide={onClose} className="with-form discovery-filter-mobile-modal discovery-filter-mobile-modal--fullscreen city-comment-mobile-sheet" aria-labelledby="mobile-comment-detail-title">
            <div className="discovery-filter-mobile-panel">
                <div className="discovery-filter-mobile-panel__header">
                    <Modal.Title id="mobile-comment-detail-title">Comment details</Modal.Title>
                    <div className="discovery-filter-mobile-panel__header-actions">
                        <button type="button" className="discovery-filter-mobile-panel__close" onClick={onClose} aria-label="Close comment details">&times;</button>
                    </div>
                </div>
            <Modal.Body>
                <div className="mobile-comment-gallery">
                    {photos.length ? <img className="mobile-comment-gallery__main" src={photos[photoIndex]} alt={`Comment attachment ${photoIndex + 1}`} />
                        : <div className="mobile-comment-card__image"><img className="mobile-comment-card__placeholder" src={icImg} alt="No attachment" /></div>}
                    {photos.length > 1 && <div className="mobile-comment-gallery__thumbnails">
                        {photos.map((photo, index) => <button key={index} type="button" aria-label={`Show photo ${index + 1}`} aria-pressed={index === photoIndex} onClick={() => setPhotoIndex(index)}><img src={photo} alt="" /></button>)}
                    </div>}
                </div>
                <h2>{comment.commentClass || '—'}</h2>
                <dl className="mobile-comment-detail-fields">
                    <dt>Price</dt><dd>{commentPrice(comment)}</dd>
                    <dt>Status</dt><dd><CommentStatus status={comment.status} /></dd>
                    <dt>User</dt><dd>{commentUserName(comment)}</dd>
                    {showEmail && <><dt>Email</dt><dd>{comment.user?.email || '—'}</dd></>}
                    <dt>Comment</dt><dd className="mobile-comment-full-text">{comment.comment || comment.text || '—'}</dd>
                    {['fromDate', 'toDate'].map((field, index) => comment[field] && <div key={field}><dt>{index === 0 ? 'From' : 'To'}</dt><dd>{new Date(comment[field]).toLocaleDateString('de-CH')}</dd></div>)}
                    <dt>Abroadify reviewed</dt><dd>{comment.approvedReview === true ? 'Yes' : 'No'}</dd>
                </dl>
            </Modal.Body>
                <div className="discovery-filter-mobile-panel__footer">
                    <Button variant="primary" className="discovery-filter-mobile-panel__apply" onClick={onClose}>Back to Comments</Button>
                </div>
            </div>
        </Modal>
    );
}
